export default __webpack_public_path__ + "static/media/PenWriting.6bba7c0c.mov";